import React, { useState } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "components/CustomButtons/Button.jsx";
import { API_POST } from "../../../services/api.service";
import { DialogActions, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const WhatsappDialog = ({
  setopenwhatsappPhoneId,
  openwhatsappPhoneId,
  whatsappDevices,
  selectedWhatsapp,
  setselectedWhatsapp,
  selectedMember,
  savewhatsappPhoneId,
  userInfo,
  user,
  managers,
  history,
}) => {

  console.log("trigger,,,,,",whatsappDevices,selectedWhatsapp,openwhatsappPhoneId);

  return (
    <>
      <Dialog
        onClose={() => setopenwhatsappPhoneId(false)}
        aria-labelledby="whatsapp-setting-dialog"
        open={openwhatsappPhoneId}
        fullWidth
      >
        <DialogTitle id="whatsapp-setting-dialog">WhatsApp Setting</DialogTitle>
        <DialogContent>
          <FormControl fullWidth margin="normal">
            <InputLabel>Select WhatsApp</InputLabel>
            <Select
              value={selectedWhatsapp || ""}
              onChange={(e) => setselectedWhatsapp(e.target.value)}
            >
              {whatsappDevices.map((device) => (
                <MenuItem key={device.key} value={device.key}>
                  {device.value} ({device.key})
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setopenwhatsappPhoneId(false)}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => savewhatsappPhoneId()}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WhatsappDialog;